import { Link } from 'react-router-dom';
import logoHorizontal from '@assets/images/logo/logo-horizontal.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='bg-gradient-to-br from-primary-cold/5 to-primary-cold/15 pt-16 pb-8 relative overflow-hidden'>
      <div className='absolute inset-0 overflow-hidden'>
        <div className='absolute -right-20 -bottom-20 h-96 w-96 rounded-full bg-primary-cold/10 blur-3xl'></div>
        <div className='absolute left-1/3 -top-20 h-80 w-80 rounded-full bg-secondary/5 blur-3xl'></div>
      </div>

      <div className='container-custom relative z-10'>
        <div className='grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4'>
          {/* Logo and description */}
          <div className='space-y-6'>
            <Link to='/' className='inline-block group'>
              <div className='p-2  transition-all duration-300'>
                <img
                  src={logoHorizontal}
                  alt='Instituto Creciendo'
                  className='h-20 object-contain'
                />
              </div>
            </Link>
            <p className='text-gray-medium max-w-xs leading-relaxed'>
              Servicios integrados de salud y educación, ofreciendo
              diagnósticos, prevención, estimulación, reeducación y tratamiento
              en diversas especialidades técnicas.
            </p>

            <div className='flex space-x-4 pt-2'>
              {/* Social Media Icons with proper icons */}

              <a
                href='https://www.instagram.com/institutocreciendonh/'
                className='flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md text-gray-medium hover:text-primary hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1'
                aria-label='Instagram'
                target='_blank'
                rel='noopener noreferrer'
              >
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 24 24'
                  aria-hidden='true'
                >
                  <path
                    fillRule='evenodd'
                    d='M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z'
                    clipRule='evenodd'
                  />
                </svg>
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div>
            <h3 className='text-lg font-nunito font-bold mb-6 border-b-2 border-primary-cold/20 pb-2 inline-block'>
              Enlaces Rápidos
            </h3>
            <ul className='space-y-3'>
              <li>
                <Link
                  to='/nosotros'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Quiénes Somos
                </Link>
              </li>
              <li>
                <Link
                  to='/nosotros#equipo'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Nuestro Equipo
                </Link>
              </li>
              <li>
                <Link
                  to='/contacto'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className='text-lg font-nunito font-bold mb-6 border-b-2 border-primary-cold/20 pb-2 inline-block'>
              Servicios
            </h3>
            <ul className='space-y-3'>
              <li>
                <Link
                  to='/servicios#psicomotriz'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Área Psicomotriz
                </Link>
              </li>
              <li>
                <Link
                  to='/servicios#fonoaudiologia'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Área Fonoaudiológica
                </Link>
              </li>
              <li>
                <Link
                  to='/servicios#psicopedagogia'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Área Psicopedagógica
                </Link>
              </li>
              <li>
                <Link
                  to='/servicios#fisioterapia'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Área de Fisioterapia
                </Link>
              </li>
              <li>
                <Link
                  to='/servicios#psicologia'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Área Psicológica
                </Link>
              </li>
              <li>
                <Link
                  to='/servicios#psiquiatria'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Área Psiquiátrica
                </Link>
              </li>
              <li>
                <Link
                  to='/servicios#musicoterapia'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Musicoterapia
                </Link>
              </li>
              <li>
                <Link
                  to='/servicios#talleres'
                  className='text-gray-medium hover:text-primary transition-all hover:translate-x-1 inline-flex items-center'
                >
                  Talleres para Adultos Mayores
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className='text-lg font-nunito font-bold mb-6 border-b-2 border-primary-cold/20 pb-2 inline-block'>
              Contacto
            </h3>
            <ul className='space-y-4'>
              <li className='text-gray-medium flex items-start  transition-all hover:translate-x-1 '>
                <svg
                  className='w-5 h-5 mr-3 text-primary mt-0.5 flex-shrink-0'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z'
                  />
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M15 11a3 3 0 11-6 0 3 3 0 016 0z'
                  />
                </svg>
                <a
                  href='https://maps.app.goo.gl/5wkdrZ6R254VAeZc9'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-gray-medium hover:text-primary'
                >
                  <span>Berna 1336, Nueva Helvecia.</span>
                </a>
              </li>
              <li className='text-gray-medium flex items-start transition-all hover:translate-x-1'>
                <svg
                  className='w-5 h-5 mr-3 text-primary mt-0.5 flex-shrink-0'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'
                  />
                </svg>
                <a
                  href='tel:+59845544595'
                  className='text-gray-medium hover:text-primary'
                >
                  <span>4554-4595</span>
                </a>
              </li>
              <li className='text-gray-medium flex items-start'>
                <svg
                  className='w-5 h-5 mr-3 text-primary mt-0.5 flex-shrink-0'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
                <span>Lunes a viernes 9:00 - 18:00hs</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='mt-16 border-t border-gray-medium/20 pt-4'>
          <div className='flex flex-col items-center justify-center md:flex-row '>
            <p className='text-sm text-gray-medium'>
              © {currentYear} Instituto Creciendo. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
